<template>
  <div class="fire-fighting-img">
    <div class="select-btn">
      <div
        class="btn-item"
        v-for="(item, index) in btnStatus"
        :key="`statusBtn${index}`"
        :class="{ 'btn-select': index == statusIndex }"
        @click="changeStatus(index)"
      >
        {{ item }}
      </div>
    </div>
    <div class="alarm-content">
      <template v-if="showListLength != 0">
        <alarm-panel
          v-for="(item, index) in showList"
          :key="`alarm${index}`"
          :panelIcon="getMoudleIcon(item.module)"
          :panelModel="getMoudleName(item.module)"
          :warnTime="getTime(item.alarmTime * 1)"
          :warnMessage="item.content"
          :floor="item"
          :isDispose="true"
          class="subPanel"
        ></alarm-panel>
      </template>
      <template v-else>
        <div class="noData-img">
          <img src="@/assets/cut/no-data.png" alt="" />
        </div>
      </template>
    </div>
    <div class="page-select">
      <el-pagination
        :hide-on-single-page="true"
        background
        layout="prev, pager, next"
        :page-size="10"
        :current-page="currentIndex"
        :total="showListLength"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getAlarmDataHistorical } from "@/api";
export default {
  data() {
    return {
      currentIndex: 1,
      timer:null,
      statusIndex: 0,
      historyList: [],
      historyTotalLength: 0,
      btnStatus: ["未处理", "处理中", "历史记录"],
      moudleMap: {
        GD: {
          name: "供电系统",
          icon: require("@/assets/moduleIcon/gd.png"),
        },
        XF: {
          name: "消防",
          icon: require("@/assets/moduleIcon/xf.png"),
        },
        AF: {
          name: "安防",
          icon: require("@/assets/moduleIcon/af.png"),
        },
        KT: {
          name: "空调",
          icon: require("@/assets/moduleIcon/kt.png"),
        },
        DT: {
          name: "电梯",
          icon: require("@/assets/moduleIcon/dt.png"),
        },
        ZM: {
          name: "照明",
          icon: require("@/assets/moduleIcon/zm.png"),
        },
        CG: {
          name: "车管",
          icon: require("@/assets/moduleIcon/cg.png"),
        },
        JL: {
          name: "计量",
          icon: require("@/assets/compImg/icon/env-icon.png"),
        },
        HJ: {
          name: "环境",
          icon: require("@/assets/moduleIcon/hj.png"),
        },
        SB: {
          name: "水泵",
          icon: require("@/assets/moduleIcon/shben.png"),
        },
        WM: {
          name: "水表",
          icon: require("@/assets/moduleIcon/sb.png"),
        },
        WG: {
          name: "网关",
          icon: require("@/assets/moduleIcon/wg.png"),
        },
        PS: {
          name: "排水",
          icon: require("@/assets/moduleIcon/ps.png"),
        },
      },
    };
  },
  watch: {
    "$parent.value"(newV) {
      this.filterSearch();
    },
    "$parent.selectDate"(newV) {
      this.filterSearch();
    },
    "$parent.input2"() {
      this.filterSearch();
    },
    statusIndex(newv, oldValue) {
      this.filterSearch();
    },
  },
  computed: {
    showList() {
      return this.historyList;
    },
    // filterList() {
    //   let arr = [];
    //   if (this.statusIndex == 0 || this.statusIndex == 1) {
    //     // 筛选模块
    //     if (this.$parent.value) {
    //       this.currentIndex = 1;
    //       if (this.$parent.value == "all") {
    //         arr = this.alarmList;
    //       } else {
    //         arr = this.alarmList.filter((item) => {
    //           if (item.module == this.$parent.value) return item;
    //         });
    //       }
    //     } else {
    //       arr = this.alarmList;
    //     }
    //     // 筛选日期
    //     if (this.$parent.selectDate) {
    //       this.currentIndex = 1;
    //       arr = arr.filter((item) => {
    //         let time = this.getTime(item.alarmTime);
    //         if (time.includes(this.$parent.selectDate)) {
    //           return item;
    //         }
    //       });
    //     }
    //     // 筛选文字
    //     if (this.$parent.input2) {
    //       this.currentIndex = 1;
    //       arr = arr.filter((item) => {
    //         if (item?.content?.includes(this.$parent.input2)) {
    //           return item;
    //         }
    //       });
    //     }
    //     arr = arr.filter((item) => item.status == this.statusIndex);
    //     return arr;
    //   }
    // },
    showListLength() {
      return this.historyTotalLength;
    },
  },
  created() {
    this.filterSearch();
  },
  methods: {
    filterSearch(e = null) {
      if (e) {
        this.currentIndex = e;
      } else {
        this.currentIndex = 1;
      }
      let sendParams = Object.create(null);
      sendParams.size = 10;
      sendParams.page = this.currentIndex;
      if (this.$parent.value && this.$parent.value !== "all") {
        sendParams.module = this.$parent.value;
      }
      if (this.$parent.selectDate) {
        sendParams.alarmTime = this.$parent.selectDate;
      }
      if (this.$parent.input2) {
        sendParams.content = this.$parent.input2;
      }
      sendParams.status = this.statusIndex;
      this.getAlarmDataHistorical(sendParams);
    },
    async getAlarmDataHistorical(parmas) {
      let { data: res } = await getAlarmDataHistorical(parmas);
      if (res) {
        this.historyList = res.records;
        this.historyTotalLength = res.total;
      } else {
        this.historyList = [];
        this.historyTotalLength = 0;
      }
    },
    changeStatus(index) {
      this.statusIndex = index;
    },
    getMoudleName(key) {
      return this.moudleMap[key]?.name || "";
    },
    getMoudleIcon(key) {
      return (
        this.moudleMap[key]?.icon ||
        require("@/assets/compImg/icon/equipment.png")
      );
    },
    getTime(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    changePage(e) {
      this.currentIndex = e;
      this.filterSearch(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.fire-fighting-img {
  width: 100%;
  height: 100%;
  .select-btn {
    width: 299px;
    display: flex;
    justify-content: space-between;
    .btn-item {
      width: 79px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 18px;
      color: #afafaf;
      line-height: 27px;
      cursor: pointer;
    }
    .btn-select {
      font-weight: 700;
      color: #ffffff;
    }
  }
  .alarm-content {
    height: 712px;
    padding-top: 10px;
    margin-bottom: 30px;
    .subPanel:not(:first-child) {
      margin-top: 20px;
    }
    .noData-img {
      background: rgba(0, 0, 0, 0.4);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 80px;
        height: 112px;
      }
    }
  }
  .page-select {
    height: 30px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    ::v-deep .el-pagination {
      color: #afafaf;
    }
    ::v-deep .el-pagination.is-background {
      .btn-prev,
      .btn-next {
        background-color: transparent;
        color: #afafaf;
      }
      .el-pager li {
        background: linear-gradient(
          179.85deg,
          rgba(255, 255, 255, 0.13) 0.13%,
          rgba(0, 0, 0, 0) 49.7%
        );
        color: #afafaf;
      }
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: rgba(255, 255, 255, 0.28);
      color: #ffffff;
    }
  }
}
</style>
